/* @flow */

import {createSelector} from 'reselect';

import type {NutshellState} from '../../store';
import {getUIState} from '../ui-selectors';

import type {OpenableModalId} from './openable-modals';

const getOpenableModalsState = createSelector([getUIState], (uiState) => uiState.openableModals);

export const getIsModalOpen = (state: NutshellState, modalId: OpenableModalId): boolean => {
    const openModals = getOpenableModalsState(state).openModals;

    return Boolean(
        Array.isArray(openModals) &&
            openModals.length &&
            openModals.find((openModalId) => openModalId === modalId)
    );
};

export const getOpenModals = (state: NutshellState): OpenableModalId[] => {
    return getOpenableModalsState(state).openModals;
};
